export default __webpack_public_path__ + "static/media/list.53f9b757.svg";